import { render, staticRenderFns } from "./MoreListPopup.vue?vue&type=template&id=2b58f329&scoped=true&"
import script from "./MoreListPopup.vue?vue&type=script&lang=js&"
export * from "./MoreListPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoreListPopup.vue?vue&type=style&index=0&id=2b58f329&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58f329",
  null
  
)

export default component.exports